import { Link } from "react-router-dom";
import { useFavorites } from "@/hooks/use-favorites";
import { OutcomeCard } from "@/components/outcome-card";
import type { CatalogOutcome } from "@/hooks/use-catalog";

export function FavoritesPage() {
  const { data, isLoading, error } = useFavorites();

  return (
    <div className="mx-auto max-w-6xl px-4 py-12">
      <header>
        <Link to="/" className="text-sm text-neutral-500 hover:underline">
          ← Home
        </Link>
        <h1 className="mt-2 text-3xl font-semibold tracking-tight">Favorites</h1>
        <p className="mt-1 text-sm text-neutral-500">
          Outcomes you've starred for quick access.
        </p>
      </header>

      {isLoading ? (
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-44 animate-pulse rounded-xl bg-neutral-100 dark:bg-neutral-900" />
          ))}
        </div>
      ) : error ? (
        <p className="mt-10 text-sm text-red-500">{(error as Error).message}</p>
      ) : (data?.length ?? 0) === 0 ? (
        <div className="mt-12 rounded-lg border border-dashed border-neutral-300 p-12 text-center dark:border-neutral-700">
          <p className="text-sm text-neutral-500">
            You haven't starred any outcomes yet.
          </p>
          <Link
            to="/catalog"
            className="mt-4 inline-block rounded-md bg-emerald-500 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-600"
          >
            Browse the catalog →
          </Link>
        </div>
      ) : (
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data!.map((f) => (
            <OutcomeCard key={f.id} outcome={f as unknown as CatalogOutcome} />
          ))}
        </div>
      )}
    </div>
  );
}
